import { authApi, BASE_URL, formDataApi } from "./common";

import { VerifyOtpTypes } from "../context/types";

export const getOTPService = async (prospectId: string) => {
  const response = await authApi.get(`${BASE_URL}/send_otp/${prospectId}`);
  return response;
};

export const verifyOTPService = async ({
  prospectId,
  otp,
  linkClickTime,
  otpEnteredTime,
}: VerifyOtpTypes) =>
  await authApi.post(`${BASE_URL}/verify_otp/${prospectId}`, {
    otp,
    link_click_time: linkClickTime,
    otp_entered_time: otpEnteredTime,
  });

export const submitDigitalContractService = async ({
  prospectId,
  formData,
}: {
  prospectId: string;
  formData: FormData;
}) =>
  await formDataApi.post(
    `${BASE_URL}/submit_digital_contract/${prospectId}`,
    formData
  );
